module.exports = __webpack_public_path__ + "img/2W.83966c91.jpg";